import { connect } from 'react-redux';
import { change } from 'redux-form';

import * as onboardingForm from 'login-utils/onboardingForm';

import RequiredViewingRequirementInput from './RequiredViewingRequirementInput';

const mapStateToProps = (state, _props) => {
  return {
    userHasViewedTermsAndConditionsText: onboardingForm.getValueFromKey(state, 'userViewedTermsAndConditionsText'),
  };
};

const mapDispatchToProps = dispatch => ({
  setUserHasViewedTermsAndConditionsText: () =>
    dispatch(change(onboardingForm.FORM_NAME, 'userViewedTermsAndConditionsText', true)),
});

const ConnectedRequiredViewingRequirementInput = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RequiredViewingRequirementInput);

export default ConnectedRequiredViewingRequirementInput;
